export const ClearButtonIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_26073_6120)">
        <path
          d="M7.0002 21.0002L2.7002 16.7002C1.7002 15.7002 1.7002 14.2002 2.7002 13.3002L12.3002 3.7002C13.3002 2.7002 14.8002 2.7002 15.7002 3.7002L21.3002 9.3002C22.3002 10.3002 22.3002 11.8002 21.3002 12.7002L13.0002 21.0002"
          stroke="#37373A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 21H7"
          stroke="#37373A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 11L14 20"
          stroke="#37373A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_26073_6120">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
